// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Lkdc","title":"Info_title__3eXk_","links":"Info_links__2b9fT","link":"Info_link__1fsbt","logo":"Info_logo__1gYwy"};